import Group from "@/comn/components/Group";
import { Page } from "@/comn/components/Page";
import {useAuth, useFetch, useForm, useToast} from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import {APIS, ENUMS, SF_PWD_AUTH} from "@/comn/comn/auth/services/PwdAuthService";
import {Button, Layout} from "@/comn/components";
import {useNavigate} from "react-router-dom";

/*
 * Password Authentication Component
 * !== 비밀번호 인증 Component ==!
 */
export const PwdAuth = (props:any) => {
    const { t }      = useTranslation();
    const form       = { pwdAuth: useForm({ defaultSchema: SF_PWD_AUTH }) };
    const auth       = useAuth();
    const toast      = useToast();
    const navigate   = useNavigate();
    const {close, auto} = props;

    const fetch = {
        processPwdAuth: useFetch({
              api      : () => {
                  form.pwdAuth.setValue("usrId", auth.get("usrId"));
                  form.pwdAuth.setValue("lgnTp", auth.get("lgnTp"));

                  return APIS.processPwdAuth(form.pwdAuth.getValues())
              }
            , onSuccess: () => close(ENUMS.OK)
            , onError  : (error) =>  toast.showToast({ type: "error", content: error.response.data.errorMessage })
        })
    }

    const handler = {
          btnOk   : () => fetch.processPwdAuth.fetch()
        , btnClose: () => {
              close(ENUMS.CANCLE);
              auto !== false && navigate(process.env.REACT_APP_BASE || "");
        }
    }

    return (
        <Page title={t("T_PWD_AUTH")} info={false}>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.pwdAuth.schema.pwd} />
                        </Group.Row>
                    </Group.Section>

                </Group.Body>
            </Group>

            <Group.Any>
                <Layout>
                    <Layout.Right>
                        <Button role={"ok"} onClick={handler.btnOk}/>
                        <Button role={"close"} onClick={handler.btnClose}/>
                    </Layout.Right>
                </Layout>
            </Group.Any>
        </Page>
    );
};
